import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Utils } from 'src/app/common/services/utils.service';
import { HttpRequestService } from 'src/app/common/services/http-request.service';
import * as moment from 'moment';

@Component({
  selector: 'app-shuttle-time-modal',
  templateUrl: './shuttle-time-modal.component.html',
  styleUrls: ['./shuttle-time-modal.component.css']
})
export class ShuttleTimeModalComponent implements OnInit {

  shuttleTimeTemplate = [{
    'id': 'strTripDate',
    'labelName': 'Effective Trip Date',
    'type': 'picker',
    'pickerType': 'calendar',
    'placeholder': 'DD/MM/YYYY',
    'dateFormat': 'DD/MM/YYYY',
    'isVisible': true,
    'maxDate': '',
    'minDate': '',
    'invalidDates': [],
    'disabledDays': [],
    'noOfMonths': 1,
    'validations': [Validators.required],
    'position': 2,
    'class': 'col-md-12'
  }];

  shuttleTimeConfig = {
    'showSideBar': false,
    'showReset': false
  };

  constructor(public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private utils: Utils,
    private httpService: HttpRequestService) { }

  onCloseTimeModal() {
    this.ref.close();
  }

  onConfirm() {
    const fromData = this.shuttleTimeConfig['formGroup'].getRawValue();
    let reqData = {
      'strTripDate': fromData['strTripDate'] ? this.utils.formatDate(fromData['strTripDate'], 'DD/MM/YYYY') : '',
      'strShuttleNo': this.config.data.modalData.selectedItem.PPL_SHUTTLE_NO,
      'strTripNo': this.config.data.modalData.selectedItem.TRIP_NO
    }
    const requestData = this.utils.constructRequestData(reqData, 'PPLCorePassengerLogistics', 'saveTripShtPopup');

    this.httpService.configRequestDataWithHeaders(requestData, 'post', '')
      .subscribe((response: any) => {
        this.ref.close(response);
      });
  }

  ngOnInit() {
    const modal = this.config.data.modalData.selectedItem;
    const tripDate = modal.TRIP_DATE;
    if (tripDate) {
      this.shuttleTimeTemplate[0].minDate = moment(tripDate, 'DD/MM/YYYY').add(1, 'days')['_d'];
    }
    this.shuttleTimeConfig['formGroup'] = this.utils.constructFormControlGroup(this.shuttleTimeTemplate);
  }
}
